import $ from 'jquery';
import throttle from '../util/throttle';
require('jquery-validation');

$(function($) {
    const scrollPadding = 50;

    $('.js-checkout-next').on('click', function() {
        var $target = $(this);
        var $currentStep = $target.parents('.js-checkout-step');
        var $nextStep = $($target.data('next-step'));
        var $progressStep = $($target.data('progress-step'));
        var url = window.location.href.split('?')[0];
        var stepNumber = parseInt($nextStep.data('step'));

        $currentStep.find('input, select, textarea').each(function() {
            $(this).valid();
        });

        if ($currentStep.find('.woocommerce-invalid').length > 0) {
            // Field error don't proceed to next step.
        } else {
            $('.js-progress-step.is-active').removeClass('is-active').addClass('is-completed');
            updateSummary(stepNumber)
            if (stepNumber == 3) {
                populateBillingAddress();
            }
            changeStep($nextStep, $progressStep);
            pushState({step : $nextStep.data('step')}, url + '?step=' + $nextStep.data('step'));
        }


    });

    $('.js-checkout-mobile-summary-toggle').on('click', function() {
        var $panel = $(this).siblings('.panel');
        if ($(window).width() < 1150) {
            if ($(this).hasClass('is-active')) {
                $panel.slideUp();
                $(this).removeClass('is-active');
            } else {
                $panel.slideDown();
                $(this).addClass('is-active');
            }
        }
    })

    $('.js-checkout-form').on('click', '.js-checkout-prev', function() {
        var $target = $(this);
        var $currentStep = $target.parents('.js-checkout-step');
        var $nextStep = $($target.data('next-step'));
        var $progressStep = $($target.data('progress-step'));
        var url = window.location.href.split('?')[0];
        var stepNumber = parseInt($nextStep.data('step'));

        $currentStep.removeClass('is-active');
        $('.js-progress-step.is-active').removeClass('is-active');
        $('.js-progress-step.is-completed').last().removeClass('is-completed').addClass('is-active');
        changeStep($nextStep, $progressStep);
        pushState({step : stepNumber}, url + '?step=' + stepNumber);
        updateSummary(stepNumber);
    });

    $('.js-checkout-form').on('change', '.js-billing-source', function() {
        var separate_billing_address = $(this).val();

        if (separate_billing_address == 1) {
            $('.js-billing-fields-wrapper').addClass('is-active');
            $('.js-billing-fields-wrapper input').val('');
        } else {
            populateBillingAddress();
            $('.js-billing-fields-wrapper').removeClass('is-active');
        }
    });

    $('.woocommerce-cart-form').on( "change", "input.qty", throttle((e) => {
        updateCart();
    }, 500));

    $('.woocommerce-cart-form').on('click', '.js-quantity-update', function(e) {
        e.preventDefault();

        var action = $(this).data('action');
        var $quantityWrapper = $(this).parents('.product-details__product-quantity');
        var $quantityInput = $quantityWrapper.find('input.qty');
        var itemQuantity = parseInt($quantityInput.val());
        var newQuantity;

        if (action == 'increase') {
            newQuantity = itemQuantity + 1;
        } else if (action == 'decrease' && itemQuantity > 1) {
            newQuantity = itemQuantity - 1;
        }

        if (newQuantity && itemQuantity != newQuantity) {
            $quantityInput.val(newQuantity);
            $('.js-update-cart').prop('disabled', false);
            updateCart();
        }

    });

    $('.js-checkout-form').on('click', '.js-enter-address-manually', function(e) {
        e.preventDefault();
        var $link = $(this);
        var $checkoutStep = $link.parents('.js-checkout-step');

        $checkoutStep.find('.form-row.u-hidden').removeClass('u-hidden');
        $link.parents('.form-row').hide();
    });

    $('.js-checkout-form').validate({
        errorElement: 'span',
        rules: {
            billing_email: "required",
            billing_phone: "required",
            shipping_first_name: "required",
            shipping_last_name: "required",
            shipping_address_1: "required",
            shipping_city: "required",
            shipping_postcode: "required",
        },
        errorPlacement: function(error, element) {
            element.closest('.form-row').append(error);
        },
        onsubmit: false,
        onfocusout: function (element) { $(element).valid(); },
        onkeyup: function(element,event) {
            if(event.which != 9) {
                $(element).valid();
            }
        }, //on keyup validate except the tab key
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);
            $(element).parents('.form-row').addClass('woocommerce-invalid');
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
            $(element).parents('.form-row').removeClass('woocommerce-invalid');
        },
        onclick: function (element) {
            $(element).valid();
        },
    });

    $('#shipping_address_1').prop('autocomplete', 'never');

    $('body.checkout').on('click', '.pcaitem', function(e) {
        var $checkoutForm = $('body.checkout .js-checkout-form');
        if ($('#shipping_postcode').val() && $('#shipping_postcode').val() != '') {
            $checkoutForm.find('.form-row.u-hidden').removeClass('u-hidden');
        }
    });

    $('body.checkout').on('keydown', function(e) {
        if (e.keyCode == 13) {
            var $checkoutForm = $('body.checkout .js-checkout-form');
            if ($('.pca').length > 0) {
                $checkoutForm.find('.form-row.u-hidden').removeClass('u-hidden');
            }
        }
    });

    function populateBillingAddress() {
        $('.js-checkout-form').find('input, select').each(function() {
            var $currentInput = $(this);
            var inputId = $currentInput.attr('id');
            if (inputId && inputId.indexOf('billing_') != -1 && $currentInput.parents('.js-billing-fields-wrapper').length > 0) {
                var shippingInputId = inputId.replace('billing_', 'shipping_');
                if ($('#' + shippingInputId).length && $('#' + shippingInputId).val() && ($currentInput.attr('name') != 'billing_phone' || $currentInput.attr('name') != 'billing_email')) {
                    $currentInput.val($('#' + shippingInputId).val());
                }

            }
        });
    }

    function updateCart() {
        $('.js-update-cart').trigger('click');
    }

    function updateSummary(step) {
        var $summary = $('.js-checkout-summary');
        if (step == 2 ) {
            // populate email summary line.
            $('.js-summary-contact').text($('#billing_email').val());

            // populate delivery address summary line
            if ($('#shipping_address_1').length && $('#shipping_postcode').length) {
                $('.js-summary-address').text(getDeliveryAddressText());
            }

            // ensure delivery method row is hidden
            $('.js-summary-row-3').addClass('u-hidden');

            // display summary block
            $summary.addClass('is-active');
        } else if (step == 3) {
            // populate email summary line.
            $('.js-summary-contact').text($('#billing_email').val());

            // populate delivery address summary line
            if ($('#shipping_address_1').length && $('#shipping_postcode').length) {
                $('.js-summary-address').text(getDeliveryAddressText());
            }

            // populate delivery method summary line
            var $selected_shipping_label = $(".shipping_method:checked ~ label");
            $('.js-summary-method').html($selected_shipping_label.html());
            $('.js-summary-row-3').removeClass('u-hidden');

            // display summary block
            $summary.addClass('is-active');
        } else {
            $summary.removeClass('is-active');
            $('.js-summary-row-3').addClass('u-hidden');
        }
    }

    function getDeliveryAddressText() {


        var $address = $('#shipping_address_1').val();

        if ($('#shipping_address_2').val()) {
            $address += ', ' + $('#shipping_address_2').val();
        }

        $address += ', ' + $('#shipping_city').val();

        if ($('#shipping_state').val()) {
            $address += ', ' + $('#shipping_state').val();
        }

        $address += ', ' + $('#shipping_postcode').val();
        $address += ', ' + $('#shipping_country option:selected').text();

        return $address
    }

    function changeStep($nextStep, $progressStep) {
        var headerHeight = $('.js-site-header').height();
        var offset = $('.js-checkout-form').offset().top;
        // var offset = nextStepOffset + headerHeight;

        $('.js-checkout-step').removeClass('is-active');
        $nextStep.addClass('is-active');

        $progressStep.addClass('is-active');

        $('html, body').animate({
            scrollTop: offset
        }, 1000);
    }

    function pushState(state, url) {
        history.pushState(state, null, url);
    }

    window.addEventListener('popstate', (event) => {
        var $currentStep, $nextStep, $progressStep;

        if (event.state && event.state.step == 3) {
            $currentStep = $('#checkout-delivery');
            $nextStep = $('#checkout-payment');
            $progressStep = $('#progress-step-2');

            $('#progress-step-2').removeClass('is-active').addClass('is-completed');
            changeStep($nextStep, $progressStep);
        } else if (event.state && event.state.step == 2) {
            $currentStep = $('#checkout-info');
            $nextStep = $('#checkout-delivery');
            $progressStep = $('#progress-step-2');

            $('#progress-step-3').removeClass('is-active is-completed');
            $('#progress-step-2').removeClass('is-completed');
            $('#progress-step-1').removeClass('is-active').addClass('is-completed');
            changeStep($nextStep, $progressStep);
        } else {
            $currentStep = $('#checkout-delivery');
            $nextStep = $('#checkout-info');
            $progressStep = $('#progress-step-1');

            changeStep($nextStep, $progressStep);
            $('#progress-step-3').removeClass('is-active');
            $('#progress-step-2').removeClass('is-active');
            $('.js-progress-step.is-completed').removeClass('is-completed');
        }
    });

    $(document).ready(function(){
        var uri = window.location.toString();
        if ($('body').hasClass('woocommerce-checkout') && uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
        }
    });

});
